// @ts-nocheck
import { getCurrentUser, onUserChange, refreshSession } from '../auth/session';
import { openAuthModal } from './auth-flow';
import { t } from '../i18n';
import { tryAcceptHeadstoneInvite } from './family-share';
import { navigateToMemorial } from './memorial-deep-link';
import { refreshPostsAccess } from './posts-access';

const STORAGE_KEY = 'pendingHeadstoneInvite';

export function getHeadstoneInviteFromUrl(params?: URLSearchParams): string | null {
  const search = params ?? new URLSearchParams(window.location.search);
  const token = search.get('headstone_invite')?.trim();
  return token || null;
}

function clearInviteFromUrl(): void {
  const url = new URL(window.location.href);
  if (!url.searchParams.has('headstone_invite')) return;
  url.searchParams.delete('headstone_invite');
  const next = url.pathname + (url.search ? url.search : '') + url.hash;
  window.history.replaceState({}, '', next);
}

function storeToken(token: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, token);
  } catch {
    /* ignore */
  }
}

function readStoredToken(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function clearStoredToken(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

async function consumeInvite(token: string): Promise<void> {
  const outcome = await tryAcceptHeadstoneInvite(token);
  if (outcome.needAuth) {
    storeToken(token);
    openAuthModal('login', t('pethernity.familyInviteNeedLogin'));
    return;
  }
  clearStoredToken();
  clearInviteFromUrl();
  if (outcome.ok && outcome.result?.headstoneId) {
    await refreshPostsAccess();
    navigateToMemorial({ graveId: outcome.result.headstoneId });
  }
}

export function initHeadstoneInviteDeepLink(): void {
  const urlToken = getHeadstoneInviteFromUrl();
  const stored = readStoredToken();
  const token = urlToken || stored;
  if (!token) return;

  if (urlToken) storeToken(urlToken);

  const boot = async () => {
    await refreshSession();
    if (!getCurrentUser()) {
      openAuthModal('login', t('pethernity.familyInviteNeedLogin'));
      return;
    }
    await consumeInvite(token);
  };

  boot().catch(() => null);

  onUserChange((user) => {
    const pending = readStoredToken();
    if (user && pending) consumeInvite(pending).catch(() => null);
  });
}
